import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";

export const VI_MANAGERS = ["super_admin", "direction_generale", "direction_commerciale", "responsable"];
export const VI_FINANCE = [...VI_MANAGERS, "caissier", "comptable"];
export const money = (v) => `${Math.round(v || 0).toLocaleString("fr-FR")} FCFA`;

export async function call(fn, okMsg) {
  try { const r = await fn(); if (okMsg) toast.success(okMsg); return r?.data ?? true; }
  catch (e) { toast.error(apiErr(e)); return null; }
}

export async function downloadBlob(path, filename) {
  const ok = await call(async () => {
    const res = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a"); a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
  });
  return ok;
}
